<template>
  <div class="p-buy">
    <div class="p-buy__top">
      <div class="p-buy__top-code">Артикул: {{ vendor }}</div>
      <div class="p-buy__top-favorite" :class="{'active' : isFav}" @click="addToFavs"></div>
    </div>
    <div class="p-buy__title">{{ name }}</div>
    <div class="p-buy__available">
      <div class="p-buy__available-title">Наличие</div>
      <div class="p-buy__available-list" :title="quantityTitle">
        <span :class="{'active':av_quantity >=1}"></span>
        <span :class="{'active':av_quantity >=2}"></span>
        <span :class="{'active':av_quantity >=3}"></span>
        <span :class="{'active':av_quantity >=4}"></span>
        <span :class="{'active':av_quantity >=5}"></span>
      </div>
    </div>
    <div class="p-buy__price">
      <div class="p-buy__price-current">
        <animated-number :number="Number(price)"></animated-number>
      </div>
      <div v-if="old_price > 0" class="p-buy__price-old">
        <animated-number :number="Number(actual_old_price)"></animated-number>
      </div>
      <div  v-if="av_quantity" class="p-buy__price-quantity">
        <quantity-buttons ref="quantityBtns"></quantity-buttons>
      </div>
    </div>
    <div class="p-buy__btns">
      <div v-if="av_quantity" class="btn" @click="addToBasket">В корзину</div>
      <div class="btn--white" v-if="first_step > 0" @click="toConfigurator">Индивидуальный заказ</div>
    </div>
    <div v-if="marketplaces?.length" class="p-buy__marketplaces">
      <component
        :is="marketplace.link ? 'a' : 'span'"
        v-for="marketplace in marketplaces"
        :key="marketplace.name"
        :href="marketplace.link"
        :target="marketplace.link ? '_blank' : null"
        :title="marketplace.name"
        class="p-buy__marketplace"
      >
        <img
          :src="marketplace.logo"
          :alt="marketplace.name"
          class="p-buy__marketplace-logo"
        >
      </component>
    </div>
  </div>
</template>

<script>
import QuantityButtons        from "@/components/Catalog/ProductCard/QuantityButtons";
import AnimatedNumber         from "@/components/Animation/AnimatedNumber";
import {mapState, mapActions} from "vuex";

export default {
  name       : "BuyCard",
  components : {
    QuantityButtons,
    AnimatedNumber
  },
  props      : {
    vendor             : String,
    name               : String,
    default_easy_clean : String,
    current_price      : Number,
    old_price          : {
      type    : Number,
      default : 0
    },
    id                 : Number,
    first_step         : Number,
    second_step        : Number,
    av_quantity        : Number,
    marketplaces       : Array
  },
  methods    : {
    ...mapActions([
      "ADD_BASKET_ITEM", "ADD_FAVS_ITEM", "DEL_FAVS_ITEM"
    ]),
    formatPrice( val )
    {
      return val.toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    addToBasket()
    {
      this.ADD_BASKET_ITEM({
        id       : this.id,
        quantity : this.quantity
        // easy_clean: this.moduleEasyClean.easy_clean
      });
    },
    addToFavs()
    {
      if(this.isFav)
      {
        this.DEL_FAVS_ITEM(this.id);
      }
      else
      {
        this.ADD_FAVS_ITEM({ID : this.id});
      }
    },
    toConfigurator()
    {
      localStorage.firstStep  = this.first_step;
      localStorage.secondStep = this.second_step;
      window.location.href    = "/configurator/";
    }
  },
  computed   : {
    ...mapState([
      "moduleBasket", "moduleFavorites", "moduleEasyClean"
    ]),
    isFav()
    {
      for(let fav in this.moduleFavorites.favorites)
        if(parseInt(this.moduleFavorites.favorites[fav].ID) === this.id)
        {
          return true;
        }
      return false;
    },
    quantityTitle()
    {
      return this.av_quantity > 0 ? 'В наличии' : 'Нет в наличии';
    },
    quantity()
    {
      return this.$refs.quantityBtns.amount;
    },
    price()
    {
      return Number(this.moduleEasyClean.easy_clean && this.default_easy_clean !== "Y" ?
          this.moduleEasyClean.price + this.current_price :
          this.current_price);
    },
    actual_old_price()
    {
      return Number(this.moduleEasyClean.easy_clean && this.default_easy_clean !== "Y" ?
          this.moduleEasyClean.price + this.old_price :
          this.old_price);
    }
  }
};
</script>

<style scoped>

</style>